
    import "src/shared/components/HsnFormItem/index.module.scss?farm_css_modules";
    
    export default {"formItem": `formItem-1887775f`,"formLayoutItem": `formLayoutItem-1887775f`,"select": `select-1887775f`}
    